import * as React from "react";
import Container from "./styled";

export default function Marcador({ title, pasoDos, pasoTres }) {
  return (
    <Container>
      <div className="titleContainer">
        <h2 className={title == "hidden" && "hidden"}>
          ¡Cotizaste con éxito el seguro de tu bici!
        </h2>
      </div>
      <div className="marcadoresContainer">
        <div className="marcadorCotiza">
          <span id="pasoUno"></span>
          <p>Cotizá</p>
        </div>
        <div className="marcadorElegi">
          <span
            id="pasoDos"
            className={
              pasoDos == "activo" ? "activo" : pasoDos == "hecho" && "hecho"
            }
          ></span>
          <p>Elegí</p>
        </div>
        <div className="marcadorContrata">
          <span
            id="pasoTres"
            className={
              pasoTres == "activo" ? "activo" : pasoTres == "hecho" && "hecho"
            }
          ></span>
          <p>Contratá</p>
        </div>
      </div>
    </Container>
  );
}
